<ion-content>
  <app-property-layout class="app-property-layout-preview" [showOverlay]="showOverlay" [mode]="listing.propertyLayout"
    [listing]="listing" (onClick)="previewClick()" [text]="previewMode"></app-property-layout>
  <div class="controls padding" tappable>
    <ion-button ion-button color="danger" class="close" clear (click)="close()">
      <ion-icon ios="ios-close" md="close-outline" [style.color]="'red'"></ion-icon>
    </ion-button>
  </div>
</ion-content>